import "./Schedule.scss";

import moment from "moment";
import { useTranslation } from "react-i18next";

import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import swarmImage from "../../assets/images/img_class-scheduled_busy.png";

export default function SwarmModal(props) {
  const { t } = useTranslation();

  const DialogTitle = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit * 2,
      textAlign: "center",
      fontSize: "36px",
      fontWeight: "bold",
      fontFamily: "Quicksand",
      marginTop: "35px",
    },
    closeButton: {
      top: "10px",
      right: "15px",
      color: "#403F4C",
      position: "absolute",
      marginBottom: "24px",
      width: "12px",
      height: "12px",
    },
  }))((props) => {
    const { children, classes, onClose } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit * 2,
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing.unit,
    },
  }))(MuiDialogActions);
  return (
    <Dialog open={props.openSwarm} onClose={() => props.postSchedule()} className="alert-dialog-slide boxModal">
      <DialogTitle className="alert-dialog-slide-title">
        <h2>{t("SWARMING_TITLE")}</h2>
      </DialogTitle>
      <DialogContent className="alert-dialog-slide-content">
        <img src={swarmImage} alt="Swarm Image" />
        <p>{props.alternativeTimesMessage}</p>
        <div className="timesBox">
          {props.alternativeTimes &&
            props.alternativeTimes.length > 0 &&
            props.alternativeTimes.map((time, index) => (
              <button className="new-button" onClick={() => props.postSchedule(time)} autoFocus key={index}>
                {moment(time).format("HH:mm")}
              </button>
            ))}
        </div>
      </DialogContent>
      <DialogActions className="alert-dialog-slide-actions">
        <button className="new-button" onClick={() => props.postSchedule()} autoFocus>
          {t("NO_THANKS")}
        </button>
      </DialogActions>
    </Dialog>
  );
}
